import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { AccountStatuses } from "./data/accountsTableData";
import { updateAccountCall } from "api/api";
import Modal from "../../components/modal";
import moment from "moment";

const defaultState = {
  holder_name: "",
  address: "",
  phone_number: "",
  status: "",
  account_number: "",
  free_units: 0,
  remarks: "",
  membership_date: "",
};

export default function UpdateAccountForm({ onClose, reload, account }) {
  const [state, setState] = useState(defaultState);
  const onUpdate = async () => {
    if (!state.holder_name) {
      return global.showAlert(
        "Validation Errors",
        "Holder Name is required to update an account",
        "warning"
      );
    }

    if (!state.status) {
      return global.showAlert(
        "Validation Errors",
        "Status is required to update an account",
        "warning"
      );
    }

    if (isNaN(state.free_units) || state.free_units < 0) {
      return global.showAlert(
        "Validation Errors",
        "Free units count should be a valid number",
        "warning"
      );
    }

    const { holder_name, address, phone_number, status, free_units, membership_date, remarks } =
      state;
    const response = await updateAccountCall(account.id, {
      holder_name,
      address,
      phone_number,
      status,
      free_units,
      membership_date,
      remarks,
    });
    if (response) {
      reload();
    }
  };

  useEffect(() => {
    if (account) {
      const {
        account_number,
        holder_name,
        address,
        phone_number,
        status,
        free_units,
        membership_date,
        remarks,
      } = account;
      setState({
        holder_name,
        address,
        phone_number,
        status,
        account_number,
        free_units: free_units || 0,
        membership_date,
        remarks,
      });
    }
  }, [account]);

  return (
    account && (
      <Modal
        open={open}
        title={"Update account"}
        actions={
          <MDBox display="flex" gap={1} justifyContent="right">
            <MDButton onClick={onUpdate} variant="gradient" color="info">
              submit
            </MDButton>
            <MDButton onClick={onClose} variant="gradient" color="error">
              cancel
            </MDButton>
          </MDBox>
        }
      >
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Account No"
              fullWidth
              value={state.account_number}
              disabled
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Holder Name"
              fullWidth
              value={state.holder_name}
              onChange={(event) => {
                setState({ ...state, holder_name: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Address"
              fullWidth
              value={state.address}
              onChange={(event) => {
                setState({ ...state, address: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Phone Number"
              fullWidth
              value={state.phone_number}
              onChange={(event) => {
                setState({ ...state, phone_number: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="number"
              label="Free Units"
              fullWidth
              value={state.free_units}
              onChange={(event) => {
                setState({ ...state, free_units: Number(event.target.value) });
              }}
              InputProps={{ inputProps: { min: 0 } }}
            />
          </MDBox>
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={state.status}
                label="Status"
                style={{
                  paddingBottom: "0.75rem",
                  paddingTop: "0.75rem",
                }}
                onChange={(event) => {
                  setState({ ...state, status: event.target.value });
                }}
              >
                {Object.values(AccountStatuses).map((status, index) => (
                  <MenuItem key={index} value={status}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="date"
              label="Membership Date"
              fullWidth
              value={
                state.membership_date ? moment(state.membership_date).format("YYYY-MM-DD") : ""
              }
              onChange={(event) => {
                setState({ ...state, membership_date: event.target.value });
              }}
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              type="string"
              label="Remarks"
              fullWidth
              value={state.remarks}
              onChange={(event) => {
                setState({ ...state, remarks: event.target.value });
              }}
            />
          </MDBox>
        </MDBox>
      </Modal>
    )
  );
}
